export default {
   SET_QUESTION_TYPE: "SET_QUESTION_TYPE",
};
